// extracted by mini-css-extract-plugin
export default {"imageContainer":"WideImage-module--imageContainer--q0aPO"};